import { useEffect, useState, useMemo, useRef } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { GLOBE_RADIUS } from "../lib/seismic";

// ~200 tsunami-prone coastal zone markers as a single Points cloud (one draw call).
export function TsunamiZones({ count = 200 }) {
  const [geom, setGeom] = useState(null);
  const matRef = useRef();

  useEffect(() => {
    let alive = true;
    fetch("/data/coastline.json")
      .then((r) => r.json())
      .then((data) => {
        if (!alive) return;
        const verts = [];
        for (const f of data.features || []) {
          const g = f.geometry;
          if (!g) continue;
          const lines = g.type === "MultiLineString" ? g.coordinates : [g.coordinates];
          for (const line of lines) for (const c of line) verts.push(c);
        }
        if (!verts.length) return;
        const pos = new Float32Array(count * 3);
        for (let i = 0; i < count; i++) {
          const [lon, lat] = verts[Math.floor((i / count) * verts.length)];
          const phi = (90 - lat) * (Math.PI / 180);
          const theta = (lon + 180) * (Math.PI / 180);
          const r = GLOBE_RADIUS + 0.012;
          pos[i * 3] = -r * Math.sin(phi) * Math.cos(theta);
          pos[i * 3 + 1] = r * Math.cos(phi);
          pos[i * 3 + 2] = r * Math.sin(phi) * Math.sin(theta);
        }
        const bg = new THREE.BufferGeometry();
        bg.setAttribute("position", new THREE.BufferAttribute(pos, 3));
        setGeom(bg);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [count]);

  useFrame((state) => {
    if (matRef.current) matRef.current.opacity = 0.35 + Math.sin(state.clock.elapsedTime * 1.5) * 0.15;
  });

  if (!geom) return null;
  return (
    <points geometry={geom} frustumCulled={false}>
      <pointsMaterial ref={matRef} color="#22c3e6" size={0.022} sizeAttenuation transparent opacity={0.4} depthWrite={false} blending={THREE.AdditiveBlending} toneMapped={false} />
    </points>
  );
}
